<template>
  <div class="container">
    
  </div>
</template>

<script>
  export default {
    data() {
      return {
        
      }
    },
    mounted() {
      window.location.href='https://unionfit.oss-cn-shanghai.aliyuncs.com/apk/%E6%96%90%E7%87%83%E7%94%9F%E6%B4%BB.apk'
    },
    methods: {
      
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  
</style>



// WEBPACK FOOTER //
// src/components/download/download.vue